import "core-js/modules/es6.object.assign";

var e = {
  none: "0px",
  xs: "0.125rem",
  sm: "0.25rem",
  md: "0.5rem",
  lg: "1rem",
  xl: "2rem",
  xxl: "4rem"
},
    r = function r(_r) {
  return void 0 === _r && (_r = {}), Object.assign({}, e, _r);
},
    l = {
  smallOnly: 639,
  mediumOnly: [640, 1023],
  largeOnly: [1024, 1199],
  xlargeOnly: [1200, 1439],
  medium: 1023,
  large: 1199,
  xlarge: 1439,
  xxlarge: 1920
},
    n = function n(e) {
  return void 0 === e && (e = {}), Object.assign({}, l, e);
};

export { e as spacing, r as mergeSpacings, l as breakPoints, n as mergeBreakpoints };